import Icon from "components/icon_implementation_details"

export default function ChurchCenterIcon(props) {
  return <Icon pathPrefix="/registrations" {...props} />
}
